export enum PopupsItem {
    couponWheelPopup = 'couponWheelPopup',
    videoPopup = 'videoPopup'
}

export enum FixedItem {
    couponWheelFixed = 'couponWheelFixed',
    defaultFixed = 'defaultFixed'
}

export enum StateType {
    Popup = 'popup',
    Fixed = 'fixed',
}

/**
 * 优先显示顺序，false为当前不显示
 */
const DefaultPopup: IItemState[] = [
    {
        key: PopupsItem.couponWheelPopup,
        status: 'false',
    },
    {
        key: PopupsItem.videoPopup,
        status: 'false',
    }
]

const DefaultFixed: IItemState[] = [
    {
        key: FixedItem.couponWheelFixed,
        status: 'false',
    },
    {
        key: FixedItem.defaultFixed,
        status: 'false',
    }
]


export type IStatus = 'false' | 'true' | 'loading';
export type IItemState = {
    key: string;
    status: IStatus
}
export type IPopupFixedState = {
    popup: IItemState[];
    fixed: IItemState[];
}

export type IPopupFixedStore = {
    state: IPopupFixedState;
    getTargetState: (
        type: StateType,
        target: PopupsItem | FixedItem,
    ) => IStatus | '';
    changeState: (
        type: StateType,
        target: PopupsItem | FixedItem,
        status: IStatus,
    ) => void;
    checkDisPlayInOrder: (
        type: StateType,
        target: PopupsItem | FixedItem,
        status?: IStatus, // 直接设置当前值为 true, 然后进行判断
    ) => boolean;
}
/**
 * 根据 DefaultPopup 数据顺序判断弹窗展示
 * 根据 DefaultFixed 数组顺序判断左下角浮窗展示
 * @param state
 */
export const createPopupFixedStore = (state?: IPopupFixedState): IPopupFixedStore => ({
    state: state || {
        popup: DefaultPopup,
        fixed: DefaultFixed,
    },
    getTargetState(
        type,
        target,
    ) {
        return this.state?.[type]?.find((item) => item.key == target)?.status || '';
    },
    changeState(
        type,
        target,
        status
    ) {
        if (type && target) {
            const _arr = this.state[type] || []
            const targetIndex = _arr?.findIndex(item => item.key === target)
            if (targetIndex > -1) {
                this.state[type][targetIndex].status = status;
            }
        }
    },
    checkDisPlayInOrder(
        type,
        target,
        status
    ) {
        // 按照顺序判断是否展示, 只有前面的数据为 false, 再判断后续的，当前为true可以展示

        if (type && target) {
            const _arr = this.state[type] || []

            if (status && (status != this.getTargetState(type, target))) {
                this.changeState(type, target, status)
            }

            for (let i = 0; i < _arr.length; i++) {
                let item = this.state[type][i]
                if (item.key === target) {
                    return status === 'true' || item.status === 'true';

                } else {
                    if (item.status !== 'false') {
                        return false
                    }
                }
            }
        }
        return false
    }

})

export default createPopupFixedStore